import React from 'react';
import AssetItem, {
  AssetItemProps,
} from 'src/components/ServiceRequestForm/AssetItem/AssetItem';
import {
  useWarrantyExpiredAssets,
  UseWarrantyExpiredAssetsReturn,
} from 'src/SharedCustomHooks/UseWarrantyExpiredAssets/useWarrantyExpiredAssets';

interface RoomAssetsProps
  extends Omit<AssetItemProps, 'asset' | 'isExpired'> {
  rooms: any[];
  room: any;
}

const RoomAssets = ({
  rooms,
  room,
  serviceRequestFormData,
  onSetServiceRequestFormData,
  onFetchFaqsNotesDocuments,
}: RoomAssetsProps) => {
  const {
    uniqueAssets,
    isAssetExpiredForResident,
  }: UseWarrantyExpiredAssetsReturn = useWarrantyExpiredAssets(rooms);

  if (serviceRequestFormData.viewAsset !== room.name) {
    return null;
  }

  return (
    <>
      {uniqueAssets.map((asset: any, x: number) => (
        <AssetItem
          key={x}
          asset={asset}
          isExpired={isAssetExpiredForResident(asset.warrantExpiration)}
          serviceRequestFormData={serviceRequestFormData}
          onSetServiceRequestFormData={onSetServiceRequestFormData}
          onFetchFaqsNotesDocuments={onFetchFaqsNotesDocuments}
        />
      ))}
    </>
  );
};

export default RoomAssets;